import xmail from "../../../api/api";
import OrgContacts from "../../core/common/OrgContacts";
import TreeUtil from "../tree/TreeUtil";
import storeLocal from 'store';


export default {
    data: function () {
        return {
            orgTrees: [],
            persTrees: [],
            selector: {
                selectIds: new Map(),
            },
            configSetting: {},
            persAddressPriv: true
        };
    },

    mounted() {
        this.configSetting = storeLocal.get('Pwm-configSetting');
        this.persAddressPriv = this.hasPriv(xmail.enums.UserPrivilege.USER_CONTACT);

        this.loadOrgTree();
        this.loadPersTree();
    },

    computed: {},

    methods: {
        hasPriv(priv) {
            return (this.configSetting.priviage.priviage1 & (1 << (priv - 1))) > 0;
        },

        /**
         * 获取组织通讯录数据，并初始化tree
         */
        loadOrgTree() {
            if (this.disableOrgContact) {
                return;
            }
            let self = this;
            let orgVersion =  storeLocal.get('ls_org_version');
            OrgContacts.getCorpOrgTrees(function (nodes) {
                if (!nodes) {
                    return;
                }
                let orgVer = nodes.version;
                let orgNodes = [];
                if (orgVer === orgVersion) {
                    orgNodes = storeLocal.get('ls_org_address') ? storeLocal.get('ls_org_address') : self.$store.getters.orgAddress;
                } else {
                    orgNodes = nodes.orgTrees;
                    storeLocal.set('ls_org_version', orgVer);
                    try {
                        storeLocal.set('ls_org_address', orgNodes);
                    } catch (e) {
                        self.$store.commit('SET_ORG_ADDRESS', orgNodes);
                    }
                }
                self.initOrgTree(JSON.parse(JSON.stringify(orgNodes)));
            }, orgVersion);
        },

        /**
         * 获取个人通讯录数据，并初始化tree
         */
        loadPersTree() {
            if (this.disablePersContact) {
                return;
            }
            let self = this;
            let persVersion = this.$store.getters.persVersion;
            OrgContacts.getPersAddressTrees(function (nodes) {
                if (!nodes) {
                    return;
                }
                let perVer = nodes.contactVersion;
                let persNodes = [];
                if (!nodes.versionChange) {
                    persNodes = storeLocal.get('ls_pers_address') ? storeLocal.get('ls_pers_address') : self.$store.getters.persAddress;
                } else {
                    persNodes = nodes.userContactTrees;
                    self.$store.commit('SET_PERS_VERSION', perVer);
                    try {
                        storeLocal.set('ls_pers_address', persNodes);
                    } catch (e) {
                        self.$store.commit('SET_PERS_ADDRESS', persNodes);
                    }
                }
                self.initPersTree(JSON.parse(JSON.stringify(persNodes)));
            }, persVersion);
        },

        initOrgTree(nodes) {
            nodes.forEach((item, index) => {
                if(nodes[index].type === xmail.enums.OrgTreeNodeType.CONTACT_GROUP) {
                    nodes[index].name = this.$i18n.t('custom_lang_0061')
                }
                if(nodes[index].type === xmail.enums.OrgTreeNodeType.MAILLIST_ROOT) {
                    nodes[index].name = this.$i18n.t('wm_lang_6b0fd2')
                }
            });
            let orgTreeRoot = [{id: "orgRoot", pinyin: 'root', type: 2, name: this.$i18n.t('wm_lang_d43e13'), children: nodes}];

            //通讯录权限
            const orgPriv = this.hasPriv(xmail.enums.UserPrivilege.ORG_CONTACT);
            const contactPriv = this.hasPriv(xmail.enums.UserPrivilege.CORP_CONTACT);
            const maillistPriv = this.hasPriv(xmail.enums.UserPrivilege.MAIL_LIST);

            if (!(orgPriv && contactPriv && maillistPriv)) {
                if (!this.contactTreeOption) {
                    this.contactTreeOption = {};
                }
                this.contactTreeOption.predHiddened = n => {
                    return (n.type === xmail.enums.OrgTreeNodeType.ORG_ROOT && !orgPriv)
                        || (n.type === xmail.enums.OrgTreeNodeType.CONTACT_GROUP && !contactPriv)
                        || (n.type === xmail.enums.OrgTreeNodeType.MAILLIST_ROOT && !maillistPriv);
                };
            }

            TreeUtil.initTree(orgTreeRoot, this.contactTreeOption);
            this.orgTrees.splice(0, this.orgTrees.length);
            for (let node of orgTreeRoot) {
                this.orgTrees.push(node);
            }

            //写信页组织联系人数据注入
            if ('function' === typeof this.getOrgTrees) {
                this.getOrgTrees(orgTreeRoot);
            }
        },

        initPersTree(nodes) {
            nodes.forEach((item, index) => {
                if(nodes[index].id === 'def') {
                    nodes[index].name = this.$i18n.t('wm_lang_a8b0c2')
                }
            });
            let persTreeRoot = [{id: "persRoot", type: 2, name: this.$i18n.t('wm_lang_d3298c'), pinyin: "ge ren tong xun lu", children: nodes}];
            TreeUtil.initTree(persTreeRoot, this.contactTreeOption);
            this.persTrees.splice(0, this.persTrees.length);
            for (let node of persTreeRoot) {
                this.persTrees.push(node);
            }

            //写信页个人联系人数据注入
            if ('function' === typeof this.getPersTrees) {
                this.getPersTrees(persTreeRoot);
            }
        },

        clearSelected() {
            TreeUtil.unSelectAll(this.orgTrees, this.selector.selectIds);
            TreeUtil.computeSelectedCount(this.orgTrees);
            TreeUtil.unSelectAll(this.persTrees, this.selector.selectIds);
            TreeUtil.computeSelectedCount(this.persTrees);
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/core/common/BaseContactTree.js